export { default } from "./AvatarDescription.vue";
